"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const constants_1 = require("../../constants");
const steps_1 = require("./steps");
exports.runStepOnElement = (options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { step, log } = options;
    let { el } = options;
    const meta = constants_1.CONVERSION_STEP_META[step.type];
    //   log('debug', {
    //     message: `${meta.activeTense}...`,
    //     parentTimestamp: options.parentTimestamp,
    //   });
    if (step.type === 'screenshot') {
        el = yield steps_1.screenshot(options);
    }
    else if (step.type === 'remove') {
        el = yield steps_1.remove(options);
    }
    else if (step.type === 'unwrap') {
        el = yield steps_1.unwrap(options);
    }
    else if (step.type === 'renameAttribute') {
        el = yield steps_1.renameAttribute(options);
    }
    else if (step.type === 'updateAttributeContents') {
        el = yield steps_1.updateAttributeContents(options);
    }
    else if (step.type === 'insertAd') {
        el = yield steps_1.insertAd(options);
    }
    else {
        log('warn', {
            message: `Conversion step "${meta.displayName}" has no actions. Doing nothing...`,
        });
    }
    yield options.onChange();
    return el;
});
//# sourceMappingURL=runStepOnElement.js.map